<agr-print-page
  orientation="portrait"
  class="print-only"
  [showHeaderImage]="false"
  [showPageNumber]="false"
  [footerText]="footerText$ | async"
  [marginLeft]="true"
  [customizedLogoSrc]="customizedLogoSrc"
  [showAgrifirmLogo]="showAgrifirmLogo"
  *ngIf="{
    totalsExcludingDepartures: totalsExcludingDepartures$ | async,
    totalAmountIncludingVatPrint: totalAmountIncludingVatPrint$ | async,
    totalIsPositive: totalIsPositive$ | async,
    additionalInvoicesTotal: additionalInvoicesTotal$ | async,
    additionalInvoices: additionalInvoices$ | async,
    fixedPriceCorrection: fixedPriceCorrection$ | async,
  } as data"
>
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="container-gap mat-small page-break-before" *ngIf="location$ | async as location">
      <div class="row-space-between">
        <div>
          <span>
            {{ location?.name }} <br />
            {{ location?.street }} {{ location?.houseNumber ?? '' }}
            {{ location?.houseNumberAddition ?? '' }} <br />
            <span class="bold underline">{{ location?.postalCode }} {{ location?.city }}</span>
          </span>
        </div>
        @if (showAgrifirmLogo) {
          <div class="line-height-compact align-right">
            <span>
              <strong>Agrifirm NWE BV</strong> <br />
              Landgoedlaan 20 <br />
              Postbus 20004 <br />
              7302 HA <br />
              Apeldoorn <br />
              www.agrifirm.nl <br />
              <strong>BTW</strong> NL007611900B01 <br />
              <strong>KvK</strong> 16050353 <br />
            </span>
          </div>
        }
      </div>

      <div class="row-space-between">
        <div>
          <span class="bold underline">Klantnummer:</span>
          &nbsp;
          <span class="italic">{{ location?.externalId }}</span>
        </div>
        <div>
          <span class="italic">{{ currentDate | agrDate: 'dd-MM-yyyy' }}</span>
        </div>
      </div>

      <div>
        <span>
          {{ 'final-setup.print-message-line-1' | translate }} <br />
          {{ 'final-setup.print-message-line-2' | translate }}
        </span>
      </div>

      <div class="spacing--margin-top">
        <table class="align-left">
          <thead>
            <tr class="bold underline">
              <th style="width: 90px">{{ 'invoice-date' | translate }}</th>
              <th style="width: 260px">{{ 'final-setup.print-description' | translate }}</th>
              <th style="width: 90px">{{ 'final-setup.print-invoice-number' | translate }}</th>
              <th style="width: 20px"></th>
              <th class="align-right">
                {{ 'final-setup.print-amount-excluding-vat' | translate }}
              </th>
              <th class="align-right">{{ 'final-setup.print-vat-amount' | translate }}</th>
              <th class="align-right">
                {{ 'final-setup.print-amount-including-vat' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let chickDelivery of chickDeliveries$ | async">
              <td>{{ chickDelivery.invoiceDateString }}</td>
              <td>{{ 'final-setup.day-old-chick' | translate }}</td>
              <td>{{ chickDelivery.invoiceNumber }}</td>
              <td>€</td>
              <td class="align-right">
                {{ chickDelivery.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ chickDelivery.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ chickDelivery.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngIf="feedDeliveriesAggregate$ | async as feedDeliveriesAggregate">
              <td></td>
              <td>{{ 'final-setup.print-total-feed' | translate }}</td>
              <td></td>
              <td>€</td>
              <td class="align-right">
                {{ feedDeliveriesAggregate?.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ feedDeliveriesAggregate?.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ feedDeliveriesAggregate?.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngIf="feedDeliveriesAggregate$ | async as feedDeliveriesAggregate">
              <td>&nbsp;</td>
            </tr>

            <tr *ngIf="data.fixedPriceCorrection">
              <td>{{ data.fixedPriceCorrection.invoiceDateString }}</td>
              <td>
                <div>
                  <p>{{ 'final-setup.fixed-price-correction' | translate }}</p>
                  <p class="italic text--small line-height-compact negative-top-margin">
                    ({{ 'final-setup.price-agreement' | translate }} €{{
                      data.fixedPriceCorrection.pricePer100Kg | agrNumber: '1.2-2'
                    }}
                    {{ 'final-setup.per-100-kg' | translate }})
                  </p>
                </div>
              </td>
              <td>{{ data.fixedPriceCorrection.invoiceNumber }}</td>
              <td>€</td>
              <td class="align-right">
                {{ data.fixedPriceCorrection.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ data.fixedPriceCorrection.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ data.fixedPriceCorrection.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngFor="let discount of discounts$ | async">
              <td>{{ discount.invoiceDateString }}</td>
              <td>{{ discount.description }}</td>
              <td>{{ discount.invoiceNumber }}</td>
              <td>€</td>
              <td class="align-right">
                {{ discount.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ discount.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ discount.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngIf="showTotalsExcludingDepartures$ | async">
              <td></td>
              <td></td>
              <td></td>
              <td class="border-top">€</td>
              <td class="border-top align-right">
                {{ data?.totalsExcludingDepartures?.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="border-top align-right">
                {{ data?.totalsExcludingDepartures?.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="border-top align-right">
                {{ data?.totalsExcludingDepartures?.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngIf="data?.additionalInvoices?.length > 0">
              <td>&nbsp;</td>
            </tr>

            <tr *ngFor="let additionalInvoice of data.additionalInvoices">
              <td>{{ additionalInvoice.invoiceDateString }}</td>
              <td>{{ additionalInvoice.description }}</td>
              <td>{{ additionalInvoice.invoiceNumber }}</td>
              <td>€</td>
              <td class="align-right">
                {{ additionalInvoice.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ additionalInvoice.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ additionalInvoice.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr *ngIf="data?.additionalInvoices?.length > 0">
              <td></td>
              <td></td>
              <td></td>
              <td class="border-top">€</td>
              <td class="border-top align-right">
                {{ data?.additionalInvoicesTotal?.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="border-top align-right">
                {{ data?.additionalInvoicesTotal?.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="border-top align-right">
                {{ data?.additionalInvoicesTotal?.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
            </tr>

            <tr *ngFor="let departure of departures$ | async">
              <td>{{ departure.invoiceDateString }}</td>
              <td>{{ departure.description }}</td>
              <td>{{ departure.invoiceNumber }}</td>
              <td>€</td>
              <td class="align-right">
                {{ departure.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ departure.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right">
                {{ departure.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>

            <tr>
              <td>&nbsp;</td>
            </tr>

            <tr>
              <td *ngIf="data?.totalIsPositive" class="bold" colspan="2">
                {{ 'final-setup.print-to-receive' | translate }}
              </td>
              <td *ngIf="!data?.totalIsPositive" class="bold" colspan="2">
                {{ 'final-setup.print-to-pay' | translate }}
              </td>
              <td></td>
              <td class="border-bottom">€</td>
              <td class="border-bottom"></td>
              <td class="border-bottom"></td>
              <td class="border-bottom bold align-right">
                {{ data?.totalAmountIncludingVatPrint | agrNumber: '1.2-2' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="user$ | async as user">
        <span> {{ 'final-setup.print-end-line-1' | translate }} </span>
        <br />
        <div *ngIf="!data.totalIsPositive">
          <br />
          <span>{{ 'final-setup.print-payment-terms' | translate }}</span>
          <br />
        </div>
        <br />
        <span> {{ 'final-setup.print-end-line-2' | translate }} </span>
        <br />
        <span>
          {{ user?.name }}
        </span>

        <div class="spacing--margin-top">
          <span>{{ companyName$ | async }}</span> <br />
          <span>{{ companyEmail$ | async }}</span> <br />
          <span>{{ companyPhone$ | async }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="feedDeliveries$" class="mat-small table-border page-break-before">
      <div class="spacing--margin-top">
        <table class="align-left">
          <thead>
            <tr class="bold">
              <th style="width: 80px">{{ 'invoice-date' | translate }}</th>
              <th style="width: 210px">{{ 'final-setup.print-product' | translate }}</th>
              <th style="width: 70px">{{ 'final-setup.print-invoice-number' | translate }}</th>
              <th style="width: 80px" class="align-right">
                {{ 'final-setup.print-net-weight' | translate }}
              </th>
              <th style="width: 80px" class="align-right">
                {{ 'final-setup.print-amount-excluding-vat' | translate }}
              </th>
              <th style="width: 80px" class="align-right">
                {{ 'final-setup.print-vat-amount' | translate }}
              </th>
              <th style="width: 80px" class="align-right">
                {{ 'final-setup.print-amount-including-vat' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let deliveryRow of feedDeliveries$ | async">
              <td>{{ deliveryRow?.invoiceDateString }}</td>
              <td colspan="6">
                <table class="subtotal-table">
                  <!-- This header block needs to have the same (fixed) widths as the parent table -->
                  <thead>
                    <tr class="bold">
                      <th style="width: 210px"></th>
                      <th style="width: 70px"></th>
                      <th style="width: 80px"></th>
                      <th style="width: 80px"></th>
                      <th style="width: 80px"></th>
                      <th style="width: 80px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="deliveryRow?.products.length > 1">
                      <tr *ngFor="let product of deliveryRow?.products">
                        <td>
                          <strong>{{ product.productId }}</strong> - {{ product.productName }}
                        </td>
                        <td></td>
                        <td class="align-right">{{ product.baseQuantity | agrNumber }}</td>
                        <td class="align-right">€ {{ product.amount | agrNumber: '1.2-2' }}</td>
                        <td class="align-right">€ {{ product.vatAmount | agrNumber: '1.2-2' }}</td>
                        <td class="align-right">
                          € {{ product.amountIncludingVat | agrNumber: '1.2-2' }}
                        </td>
                      </tr>
                    </ng-container>
                    <tr>
                      <ng-container *ngIf="deliveryRow?.products.length > 1">
                        <td class="bold align-right" style="padding-right: 16px">
                          {{ 'final-setup.print-subtotal' | translate }}
                        </td>
                      </ng-container>
                      <ng-container *ngIf="deliveryRow?.products.length === 1">
                        <td>
                          <strong>{{ deliveryRow.products[0].productId }}</strong> -
                          {{ deliveryRow.products[0].productName }}
                        </td>
                      </ng-container>
                      <td class="bold">{{ deliveryRow?.invoiceNumber }}</td>
                      <td class="align-right">
                        {{ deliveryRow?.baseQuantity | agrNumber }}
                      </td>
                      <td class="align-right">€ {{ deliveryRow?.amount | agrNumber: '1.2-2' }}</td>
                      <td class="align-right">
                        € {{ deliveryRow?.vatAmount | agrNumber: '1.2-2' }}
                      </td>
                      <td class="align-right">
                        € {{ deliveryRow?.amountIncludingVat | agrNumber: '1.2-2' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr *ngIf="feedDeliveriesTotal$ | async as feedDeliveriesTotal">
              <td></td>
              <td class="bold">
                {{ feedDeliveriesTotal?.description }}
              </td>
              <td></td>
              <td class="align-right bold">
                {{ feedDeliveriesTotal?.baseQuantity | agrNumber }}
              </td>
              <td class="align-right bold">
                € {{ feedDeliveriesTotal?.amount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right bold">
                € {{ feedDeliveriesTotal?.vatAmount | agrNumber: '1.2-2' }}
              </td>
              <td class="align-right bold">
                € {{ feedDeliveriesTotal?.amountIncludingVat | agrNumber: '1.2-2' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</agr-print-page>
